<template>
  <main class="w-full max-w-none">
    <div class="mx-auto w-full max-w-full px-0">
      <div class="mb-8">
        <h1 class="text-2xl md:text-3xl font-bold text-gray-900 mb-2">回单批量下载</h1>
        <p class="text-gray-600">用于下载指定账号和记账日期的回单</p>
      </div>

      <div class="grid grid-cols-1 lg:grid-cols-5 gap-3 w-full">
        <!-- 左侧内容 -->
        <div class="w-full lg:col-span-3">
          <Card class="mb-8">
            <CardHeader>
              <CardTitle>接口说明</CardTitle>
              <CardDescription>
                用于下载指定账号和记账日期的回单。
                <br />
                说明：
                <br />- 两个参数均为必填 <br />- 返回二进制文件流为压缩包文件流，需解压
              </CardDescription>
            </CardHeader>
            <CardContent>
              <div
                class="flex items-center gap-4 mb-6 p-4 bg-gray-50 rounded-lg"
              >
                <span
                  class="px-3 py-1 bg-blue-100 text-blue-800 text-sm font-medium rounded-full"
                  >GET</span
                >
                <code class="text-sm font-mono">/api/v2/ebill/download</code>
              </div>

              <div class="space-y-6">
                <div>
                  <h3 class="text-lg font-medium text-gray-900 mb-3">
                    请求头参数
                  </h3>
                  <div class="overflow-x-auto">
                    <table class="min-w-max md:min-w-full divide-y divide-gray-200">
                      <thead class="bg-gray-50">
                        <tr>
                          <th
                            class="px-3 md:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                          >
                            参数名
                          </th>
                          <th
                            class="px-3 md:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                          >
                            类型
                          </th>
                          <th
                            class="px-3 md:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                          >
                            必需
                          </th>
                          <th
                            class="px-3 md:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                          >
                            描述
                          </th>
                          <th
                            class="px-3 md:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                          >
                            示例值
                          </th>
                        </tr>
                      </thead>
                      <tbody class="bg-white divide-y divide-gray-200">
                        <tr>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900"
                          >
                            x-app-id
                          </td>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm text-gray-500"
                          >
                            String
                          </td>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm text-gray-500"
                          >
                            是
                          </td>
                          <td class="px-3 md:px-6 py-4 text-sm text-gray-500">
                            APP ID
                          </td>
                          <td class="px-3 md:px-6 py-4 text-sm text-gray-500 break-all">
                            4d9414e89bc24b0d89b678d9f20bc56a
                          </td>
                        </tr>
                        <tr>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900"
                          >
                            x-app-secret
                          </td>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm text-gray-500"
                          >
                            String
                          </td>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm text-gray-500"
                          >
                            是
                          </td>
                          <td class="px-3 md:px-6 py-4 text-sm text-gray-500">
                            API Key
                          </td>
                          <td class="px-3 md:px-6 py-4 text-sm text-gray-500 break-all">
                            8201e508ef948b8fcdca855729e7ee34
                          </td>
                        </tr>
                        <tr>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900"
                          >
                            x-customer-code
                          </td>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm text-gray-500"
                          >
                            String
                          </td>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm text-gray-500"
                          >
                            是
                          </td>
                          <td class="px-3 md:px-6 py-4 text-sm text-gray-500">
                            客户编号
                          </td>
                          <td class="px-3 md:px-6 py-4 text-sm text-gray-500 break-all">
                            CUSTFA48DD8EFF437956
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                <div>
                  <h3 class="text-lg font-medium text-gray-900 mb-3">
                    请求参数
                  </h3>
                  <div class="overflow-x-auto">
                    <table class="min-w-max md:min-w-full divide-y divide-gray-200">
                      <thead class="bg-gray-50">
                        <tr>
                          <th
                            class="px-3 md:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                          >
                            参数名
                          </th>
                          <th
                            class="px-3 md:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                          >
                            类型
                          </th>
                          <th
                            class="px-3 md:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                          >
                            必需
                          </th>
                          <th
                            class="px-3 md:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                          >
                            描述
                          </th>
                          <th
                            class="px-3 md:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                          >
                            示例值
                          </th>
                        </tr>
                      </thead>
                      <tbody class="bg-white divide-y divide-gray-200">
                        <tr>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900"
                          >
                            accountNo
                          </td>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm text-gray-500"
                          >
                            String
                          </td>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm text-gray-500"
                          >
                            是
                          </td>
                          <td class="px-3 md:px-6 py-4 text-sm text-gray-500 break-all">
                            本方账号
                          </td>
                          <td class="px-3 md:px-6 py-4 text-sm text-gray-500 break-all">
                            6228480001000200003
                          </td>
                        </tr>
                        <tr>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900"
                          >
                            accountingDateId
                          </td>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm text-gray-500"
                          >
                            Number
                          </td>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm text-gray-500"
                          >
                            是
                          </td>
                          <td class="px-3 md:px-6 py-4 text-sm text-gray-500 break-all">
                            记账日期ID，格式：yyyyMMdd
                          </td>
                          <td class="px-3 md:px-6 py-4 text-sm text-gray-500 break-all">
                            20251201
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                <div>
                  <h3 class="text-lg font-medium text-gray-900 mb-3">
                    响应参数
                  </h3>
                  <div class="overflow-x-auto">
                    <table class="min-w-max md:min-w-full divide-y divide-gray-200">
                      <thead class="bg-gray-50">
                        <tr>
                          <th
                            class="px-3 md:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                          >
                            参数名
                          </th>
                          <th
                            class="px-3 md:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                          >
                            类型
                          </th>
                          <th
                            class="px-3 md:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                          >
                            描述
                          </th>
                        </tr>
                      </thead>
                      <tbody class="bg-white divide-y divide-gray-200">
                        <tr>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900"
                          >
                            二进制文件流
                          </td>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm text-gray-500"
                          >
                            Binary
                          </td>
                          <td class="px-3 md:px-6 py-4 text-sm text-gray-500">
                            返回回单压缩包文件流（需解压）。
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </CardContent>
          </Card>
        </div>

        <!-- 右侧"试一试"区域 -->
        <div class="w-full lg:col-span-2">
          <Card>
            <CardHeader>
              <CardTitle>试一试</CardTitle>
              <CardDescription>填写参数并下载回单压缩包</CardDescription>
            </CardHeader>
            <CardContent>
              <div class="border-b border-gray-200">
                <nav class="-mb-px flex space-x-8 overflow-x-auto">
                  <button
                    v-for="language in languages"
                    :key="language.id"
                    @click="activeLanguage = language.id"
                    class="whitespace-nowrap py-2 px-1 border-b-2 font-medium text-sm"
                    :class="[
                      activeLanguage === language.id
                        ? 'border-[var(--primary)] text-[var(--primary)]'
                        : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300',
                    ]"
                  >
                    {{ language.name }}
                  </button>
                </nav>
              </div>

              <div class="mt-6">
                <pre
                  class="bg-gray-800 text-gray-100 p-4 rounded-md text-sm overflow-x-auto"
                ><code>{{ getRequestText() }}</code></pre>
                <div class="space-y-4">
                  <div>
                    <label class="block text-sm font-medium text-gray-700 mb-1"
                      >x-app-id <span class="text-red-500">*</span></label
                    >
                    <input
                      v-model="appId"
                      type="text"
                      :class="{'!border-red-500': showValidation && !appId}"
                      class="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-[var(--primary)] focus:border-[var(--primary)]"
                    />
                  </div>
                  <div>
                    <label class="block text-sm font-medium text-gray-700 mb-1"
                      >x-app-secret <span class="text-red-500">*</span></label
                    >
                    <input
                      v-model="authorization"
                      type="text"
                      :class="{'!border-red-500': showValidation && !authorization}"
                      class="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-[var(--primary)] focus:border-[var(--primary)]"
                    />
                  </div>
                  <div>
                    <label class="block text-sm font-medium text-gray-700 mb-1"
                      >x-customer-code <span class="text-red-500">*</span></label
                    >
                    <input
                      v-model="customerCode"
                      type="text"
                      :class="{'!border-red-500': showValidation && !customerCode}"
                      class="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-[var(--primary)] focus:border-[var(--primary)]"
                    />
                  </div>

                  <div class="grid grid-cols-1 gap-4">
                    <div>
                      <label
                        class="block text-sm font-medium text-gray-700 mb-1"
                        >accountNo <span class="text-red-500">*</span></label
                      >
                      <input
                        v-model="accountNo"
                        type="text"
                        placeholder="622848..."
                        :class="{'!border-red-500': showValidation && !accountNo}"
                        class="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-[var(--primary)] focus:border-[var(--primary)]"
                      />
                    </div>
                    <div>
                      <label
                        class="block text-sm font-medium text-gray-700 mb-1"
                        >accountingDateId (yyyyMMdd) <span class="text-red-500">*</span></label
                      >
                      <input
                        v-model="accountingDateId"
                        type="text"
                        placeholder="20251201"
                        :class="{'!border-red-500': showValidation && !accountingDateId}"
                        class="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-[var(--primary)] focus:border-[var(--primary)]"
                      />
                    </div>
                  </div>
                  <button
                    @click="downloadReceipt"
                    :disabled="loading"
                    class="w-full bg-[var(--primary)] hover:bg-[color:var(--primary)] text-white font-medium py-2 px-4 rounded-md transition duration-200 ease-in-out transform hover:scale-105 focus:outline-none focus:ring-2 focus:ring-[var(--primary)] focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed"
                  >
                    {{ loading ? "下载中..." : "批量下载回单" }}
                  </button>
                </div>
              </div>

              <div v-if="response && !downloadUrl" class="mt-6">
                <h3 class="text-lg font-medium text-gray-900 mb-2">响应结果</h3>
                <pre
                  class="bg-gray-800 text-gray-100 p-4 rounded-md text-sm overflow-x-auto"
                ><code class="language-json">{{ response }}</code></pre>
              </div>

              <div v-if="downloadUrl" class="mt-6">
                <h3 class="text-lg font-medium text-gray-900 mb-2">下载链接</h3>
                <p class="text-sm text-gray-600 mb-2">
                  回单压缩包已生成，点击下面链接保存到本地。
                </p>
                <a
                  :href="downloadUrl"
                  :download="downloadFilename"
                  class="text-blue-600 hover:underline"
                  >{{ downloadFilename }}</a
                >
              </div>
            </CardContent>
          </Card>
        </div>
      </div>
    </div>
  </main>
</template>

<script setup lang="ts">
import { ref, onMounted, watch, nextTick } from "vue";
import Card from "./ui/Card.vue";
import CardHeader from "./ui/CardHeader.vue";
import CardTitle from "./ui/CardTitle.vue";
import CardDescription from "./ui/CardDescription.vue";
import CardContent from "./ui/CardContent.vue";
import { useCodeHighlight } from "@/composables/useCodeHighlight";
import httpService from "@/lib/http";
import hljs from "highlight.js/lib/core";

// 使用代码高亮
const highlightCode = () => {
  nextTick(() => {
    // 等待DOM更新完成后再处理
    setTimeout(() => {
      // 找到所有代码块
      const allCodeBlocks = document.querySelectorAll("pre code");

      // 语言映射表
      const languageMap: { [key: string]: string } = {
        curl: "language-bash",
        javascript: "language-javascript",
        python: "language-python",
        java: "language-java",
        csharp: "language-csharp",
        php: "language-php",
        ruby: "language-ruby",
      };

      const langClass = languageMap[activeLanguage.value];

      allCodeBlocks.forEach((block) => {
        const el = block as HTMLElement;
        const isJson = el.classList.contains("language-json");

        // 先移除所有类名
        el.className = "";
        // 移除highlight.js添加的属性
        el.removeAttribute("data-highlighted");

        el.classList.add("hljs");
        
        if (isJson) {
            el.classList.add("language-json");
        } else if (langClass) {
          el.classList.add(langClass);
        }

        try {
          hljs.highlightElement(el);
        } catch (error) {
          console.warn("代码高亮失败:", error);
        }
      });
    }, 100);
  });
};

// 初始化代码高亮
useCodeHighlight("pre code");
onMounted(() => {
  highlightCode();
});

const DEFAULT_APP_ID = "登录后自动获取";
const DEFAULT_APP_SECRET = "登录后自动获取";
const DEFAULT_CUSTOMER_CODE = "登录后自动获取";

const appId = ref(DEFAULT_APP_ID);
const authorization = ref(DEFAULT_APP_SECRET);
const customerCode = ref(DEFAULT_CUSTOMER_CODE);
const accountNo = ref("");
const accountingDateId = ref("");

const loading = ref(false);
const showValidation = ref(false);
const activeLanguage = ref("curl");
const downloadUrl = ref("");
const downloadFilename = ref("");
const response = ref("");

// 获取应用信息
const getApplicationInfo = async () => {
  try {
    const response = await httpService.get<any>("/nxb/console/application/get");

    if (response) {
      return {
        appId: response.appId,
        appSecret: response.appSecret,
      };
    }
    return null;
  } catch (error) {
    console.log("获取应用信息失败:", error);
    return null;
  }
};

// 获取客户信息
const getCustomerInfo = async () => {
  try {
    const response = await httpService.get<any>(
      "/nxb/console/customer/listWithSummary",
      {
        pageNow: 1,
        pageSize: 10,
      }
    );

    if (response) {
      return response.customers[0].customerCode;
    }
    return null;
  } catch (error) {
    console.log("获取客户信息失败:", error);
    return null;
  }
};

// 登录后自动获取用户信息
const autoFetchUserInfo = async () => {
  const userInfoStr = localStorage.getItem("userInfo");

  if (userInfoStr) {
    const appInfo = await getApplicationInfo();

    if (appInfo) {
      appId.value = appInfo.appId;
      authorization.value = appInfo.appSecret;
    }

    const customerCodeValue = await getCustomerInfo();
    if (customerCodeValue) {
      customerCode.value = customerCodeValue;
    }
  }
};

// 组件挂载时登录后自动获取用户信息
onMounted(() => {
  autoFetchUserInfo();
});

// 监听响应式变量变化，重新应用代码高亮
watch(
  [
    appId,
    authorization,
    customerCode,
    accountNo,
    accountingDateId,
    activeLanguage,
    response,
  ],
  () => {
    // 更新示例代码高亮
    highlightCode();
  },
  { flush: "post" }
);

// 语言选项
const languages = [
  { id: "curl", name: "cURL" },
  { id: "javascript", name: "JavaScript" },
  { id: "python", name: "Python" },
  { id: "java", name: "Java" },
  { id: "csharp", name: "C#" },
  { id: "php", name: "PHP" },
  { id: "ruby", name: "Ruby" },
];

// 获取请求文本
const getRequestText = () => {
  const baseUrl = import.meta.env.VITE_API_URL + "/api/v2/ebill/download";
  const params = new URLSearchParams();
  if (accountNo.value) params.append("accountNo", accountNo.value);
  if (accountingDateId.value) params.append("accountingDateId", accountingDateId.value);
  
  const qs = params.toString() || "accountNo=622848...&accountingDateId=20251201";

  switch (activeLanguage.value) {
    case "curl":
      return (
        `curl -X GET '${baseUrl}?${qs}' \\\n` +
        `  -H 'x-app-id: ${appId.value}' \\\n` +
        `  -H 'x-app-secret: ${authorization.value}' \\\n` +
        `  -H 'x-customer-code: ${customerCode.value}' \\\n` +
        `  --output receipt.zip`
      );

    case "javascript":
      return (
        `const axios = require('axios');\n\n` +
        `const config = {\n` +
        `  method: 'get',\n` +
        `  url: '${baseUrl}?${qs}',\n` +
        `  headers: {\n` +
        `    'x-app-id': '${appId.value}',\n` +
        `    'x-app-secret': '${authorization.value}',\n` +
        `    'x-customer-code': '${customerCode.value}'\n` +
        `  },\n` +
        `  responseType: 'stream'\n` +
        `};\n\n` +
        `axios(config)\n` +
        `  .then(function (response) {\n` +
        `    response.data.pipe(fs.createWriteStream('receipts.zip'));\n` +
        `  })\n` +
        `  .catch(function (error) {\n` +
        `    console.log(error);\n` +
        `  });`
      );

    case "python":
      return (
        `import requests\n\n` +
        `url = "${baseUrl}"\n` +
        `params = {\n` +
        (accountNo.value ? `  'accountNo': '${accountNo.value}',\n` : "") +
        (accountingDateId.value ? `  'accountingDateId': '${accountingDateId.value}'\n` : "") +
        `}\n` +
        `headers = {\n` +
        `  'x-app-id': '${appId.value}',\n` +
        `  'x-app-secret': '${authorization.value}',\n` +
        `  'x-customer-code': '${customerCode.value}'\n` +
        `}\n\n` +
        `with requests.get(url, headers=headers, params=params, stream=True) as r:\n` +
        `  r.raise_for_status()\n` +
        `  with open('receipts.zip', 'wb') as f:\n` +
        `    for chunk in r.iter_content(chunk_size=8192):\n` +
        `      f.write(chunk)`
      );

    case "java":
      return (
        `OkHttpClient client = new OkHttpClient().newBuilder()\n` +
        `  .build();\n` +
        `HttpUrl url = HttpUrl.parse("${baseUrl}").newBuilder()\n` +
        (accountNo.value
          ? `  .addQueryParameter("accountNo", "${accountNo.value}")\n`
          : "") +
        (accountingDateId.value
          ? `  .addQueryParameter("accountingDateId", "${accountingDateId.value}")\n`
          : "") +
        `  .build();\n` +
        `Request request = new Request.Builder()\n` +
        `  .url(url)\n` +
        `  .get()\n` +
        `  .addHeader("x-app-id", "${appId.value}")\n` +
        `  .addHeader("x-app-secret", "${authorization.value}")\n` +
        `  .addHeader("x-customer-code", "${customerCode.value}")\n` +
        `  .build();\n` +
        `Response response = client.newCall(request).execute();\n` +
        `byte[] bytes = response.body().bytes();\n` +
        `Files.write(Paths.get("receipts.zip"), bytes);`
      );

    case "csharp":
      return (
        `var client = new RestClient("${baseUrl}?${qs}");\n` +
        `var request = new RestRequest(Method.GET);\n` +
        `request.AddHeader("x-app-id", "${appId.value}");\n` +
        `request.AddHeader("x-app-secret", "${authorization.value}");\n` +
        `request.AddHeader("x-customer-code", "${customerCode.value}");\n` +
        `IRestResponse response = client.Execute(request);\n` +
        `File.WriteAllBytes("receipts.zip", response.RawBytes);`
      );

    case "php":
      return (
        `<?php\n\n` +
        `$curl = curl_init();\n\n` +
        `curl_setopt_array($curl, array(\n` +
        `  CURLOPT_URL => '${baseUrl}?${qs}',\n` +
        `  CURLOPT_RETURNTRANSFER => true,\n` +
        `  CURLOPT_CUSTOMREQUEST => 'GET',\n` +
        `  CURLOPT_HTTPHEADER => array(\n` +
        `    'x-app-id: ${appId.value}',\n` +
        `    'x-app-secret: ${authorization.value}',\n` +
        `    'x-customer-code: ${customerCode.value}'\n` +
        `  ),\n` +
        `));\n\n` +
        `$response = curl_exec($curl);\n` +
        `curl_close($curl);\n` +
        `file_put_contents('receipts.zip', $response);`
      );

    case "ruby":
      return (
        `require "uri"\n` +
        `require "net/http"\n` +
        `require "openssl"\n\n` +
        `url = URI("${baseUrl}?${qs}")\n` +
        `https = Net::HTTP.new(url.host, url.port)\n` +
        `https.use_ssl = true\n` +
        `request = Net::HTTP::Get.new(url)\n` +
        `request["x-app-id"] = "${appId.value}"\n` +
        `request["x-app-secret"] = "${authorization.value}"\n` +
        `request["x-customer-code"] = "${customerCode.value}"\n` +
        `response = https.request(request)\n` +
        `File.write("receipts.zip", response.body)`
      );

    default:
      return "";
  }
};

// 下载回单（调用 /ebill/download 返回二进制并生成下载链接）
const downloadReceipt = async () => {
  showValidation.value = true;
  
  if (!appId.value || !authorization.value || !customerCode.value) {
    // alert("请填写所有必填字段 (Header)");
    return;
  }

  if (!accountNo.value || !accountingDateId.value) {
    // alert("请填写所有必填字段 (accountNo, accountingDateId)");
    return;
  }

  loading.value = true;
  downloadUrl.value = "";
  downloadFilename.value = "";
  response.value = "";

  try {
    const params: Record<string, string> = {
        accountNo: accountNo.value,
        accountingDateId: accountingDateId.value
    };

    const res = await httpService.get<any>("/api/v2/ebill/download", params, {
      headers: {
        "x-app-id": appId.value,
        "x-app-secret": authorization.value,
        "x-customer-code": customerCode.value,
      },
      responseType: "blob",
    });

    const raw = res && (res as any).data ? (res as any).data : res;
    
    // Check if response is JSON
    if (raw instanceof Blob && raw.type === "application/json") {
        const text = await raw.text();
        try {
            const json = JSON.parse(text);
            response.value = JSON.stringify(json, null, 2);
            // Re-highlight code since we added new code block
            nextTick(() => {
                highlightCode();
            });
            return;
        } catch (e) {
            console.error("Failed to parse JSON blob", e);
        }
    }

    const blob =
      raw instanceof Blob
        ? raw
        : new Blob([raw], { type: "application/zip" });
    const url = URL.createObjectURL(blob);
    
    downloadUrl.value = url;
    downloadFilename.value = `receipts_${accountingDateId.value}.zip`;
    
    // 清除校验状态
    showValidation.value = false;
  } catch (error) {
    console.error("下载失败:", error);
    // If error is an object, try to display it
    if (error && typeof error === 'object') {
         response.value = JSON.stringify(error, null, 2);
    } else {
         response.value = String(error);
    }
    // alert("下载失败，请稍后重试或检查参数与权限");
  } finally {
    loading.value = false;
  }
};
</script>
